import { useState, useEffect } from "react";
import { C } from "../../../constants/theme";
import { corFilamentoHex } from "../../../utils/corFilamento";

// Campo de busca + lista com quadradinhos de cor pra escolher um filamento —
// usado na confirmação de cores detectadas num .3mf.
export function SeletorFilamentoInline({ filamentoId, filamentos, coresCustom, onSelect }) {
  const filSel = filamentos.find(f => f.id === filamentoId);
  const [busca, setBusca] = useState(filSel ? (filSel.cor || filSel.nome || "") : "");
  const [aberto, setAberto] = useState(false);

  useEffect(() => {
    const f = filamentos.find(x => x.id === filamentoId);
    setBusca(f ? (f.cor || f.nome || "") : "");
  }, [filamentoId]); // eslint-disable-line react-hooks/exhaustive-deps

  const filtrados = filamentos.filter(f => {
    if (!busca.trim()) return true;
    const q = busca.toLowerCase();
    return (f.cor||"").toLowerCase().includes(q) || (f.nome||"").toLowerCase().includes(q) || (f.marca||"").toLowerCase().includes(q) || (f.material||"").toLowerCase().includes(q);
  });

  return (
    <div style={{ position:"relative", flex:1, minWidth:0 }}>
      <input
        value={busca}
        onChange={e=>{ setBusca(e.target.value); setAberto(true); if (filamentoId) onSelect(""); }}
        onFocus={()=>setAberto(true)}
        onBlur={()=>setTimeout(()=>setAberto(false), 150)}
        placeholder="Buscar filamento..."
        style={{ width:"100%", boxSizing:"border-box", background:C.panel, border:"1px solid "+C.border, borderRadius:6, color:C.text, padding:"5px 8px", fontSize:12, outline:"none" }}
      />
      {aberto && (
        <div style={{ position:"absolute", top:"calc(100% + 4px)", left:0, right:0, zIndex:30, background:C.panel, border:"1px solid "+C.border, borderRadius:8, maxHeight:200, overflowY:"auto", boxShadow:"0 12px 28px rgba(0,0,0,0.45)" }}>
          {filtrados.length === 0 && (
            <div style={{ padding:"10px 12px", color:C.muted, fontSize:12 }}>Nenhum filamento encontrado</div>
          )}
          {filtrados.map(f => (
            <div key={f.id} onMouseDown={e=>{ e.preventDefault(); onSelect(f.id); setBusca(f.cor||f.nome||""); setAberto(false); }}
              style={{ display:"flex", alignItems:"center", gap:8, padding:"7px 10px", cursor:"pointer", borderBottom:"1px solid "+C.border }}>
              <div style={{ width:14, height:14, borderRadius:4, background:corFilamentoHex(f.cor, coresCustom), border:"1px solid "+C.border, flexShrink:0 }} />
              <span style={{ color:C.text, fontSize:12, fontWeight:600, flex:1, minWidth:0, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{f.cor||f.nome}</span>
              <span style={{ color:C.muted, fontSize:11, flexShrink:0 }}>{f.material}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
